export const Newsletter = {
	global: {
		form: document.getElementById("inscription_newsletter"),
		message: document.getElementById("newsletter_msg"),
		emailContainer: document.querySelector(".t-newsletter_input-container"),
		email: document.getElementById("newsletter_email")
	},
	init: function () {
		this.handleInputFocus();
		this.submitForm();
	},
	handleInputFocus: () => {
		if (Newsletter.global.email) {
			Newsletter.global.email.addEventListener("change", event => {
				if (event.target.value.length > 0) {
					return Newsletter.global.emailContainer.classList.add("t-newsletter_input-container--filled");
				}
				return Newsletter.global.emailContainer.classList.remove("t-newsletter_input-container--filled");
			});
		}
	},
	submitForm: () => {
		if (document.querySelector("#inscription_newsletter")) {
			document.querySelector("#inscription_newsletter").addEventListener("submit", e => {
				e.preventDefault(); //stop form from submitting
				Newsletter.global.message.innerHTML = "";
				Newsletter.global.message.style.opacity = "0";

				const grecaptchaResponse = grecaptcha.getResponse();

				let form = new FormData();
				form.append("newsletter_email", Newsletter.global.email.value);
				form.append("g-recaptcha-response", grecaptchaResponse);

				let xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = event => {
					let res = JSON.parse(event.target.response);

					if (res.data.status === 200) {
						Newsletter.global.message.style.color = "#356DDC";
						Newsletter.global.message.innerHTML = "Vous êtes bien inscrit à notre newsletter !";
					} else {
						grecaptcha.reset();
						Newsletter.global.message.style.color = "#FF0000";
						Newsletter.global.message.innerHTML = "Désolé, une erreur est survenue, merci de réessayer.";
					}

					Newsletter.global.message.style.opacity = "1";
				};

				xhttp.open("POST", api_newsletter.api_url, true);
				xhttp.send(form);
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/scripts/components/Newsletter.js